/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { useEffect, useRef, createRef, cloneElement, Children } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./index.module.scss";

/**
 *
 * @param {{
 * parentEl: createRef() || useRef()
 * }} props
 * @returns
 */

const Vertical = ({
  parentEl,
  useMouseWheel,
  settings,
  children,
  ...props
}) => {
  const sliderRef = useRef();

  if (settings.dots) {
    settings.appendDots = (dotList) => {
      return (
        <ul>
          {dotList.map((dot, idx) => {
            if (dot.props["className"] === "slick-active") {
              return cloneElement(dot, {
                className: `slick-active ${styles["slick-active"]}`,
                onClick: () => {
                  goToSlide(idx);
                },
              });
            } else {
              return cloneElement(dot, {
                className: "",
                onClick: () => {
                  goToSlide(idx);
                },
              });
            }
          })}
        </ul>
      );
    };
    settings.customPaging = (i) => <button>{i}</button>;

    if (settings.dotClasses) {
      const dotStyles = settings.dotClasses;

      settings.appendDots = (dotList) => {
        //with dot styles
        return (
          <ul>
            {dotList.map((dot, idx) => {
              if (dot.props["className"] === "slick-active") {
                return cloneElement(dot, {
                  className:
                    settings.dotPosition === "left" ||
                      settings.dotPosition === "right"
                      ? `slick-active ${dotStyles.vertical?.normal}  ${dotStyles.vertical?.active}`
                      : `slick-active ${dotStyles.horizontal?.normal} ${dotStyles.horizontal?.active}`,
                  onClick: () => {
                    goToSlide(idx);
                  },
                });
              } else {
                return cloneElement(dot, {
                  className:
                    settings.dotPosition === "left" ||
                      settings.dotPosition === "right"
                      ? `${dotStyles.vertical?.normal}`
                      : `${dotStyles.horizontal?.normal}`,
                  onClick: () => {
                    goToSlide(idx);
                  },
                });
              }
            })}
          </ul>
        );
      };

      settings.customPaging = (i) => <button></button>;
    }
  }

  useEffect(() => {
    if (!parentEl.current) {
      return;
    }

    if (parentEl && parentEl.current && useMouseWheel) {
      //only use mouse scroll in desktop screen
      parentEl.current.addEventListener("wheel", (e) => handleScroll(e));
    }
    return () => {
      parentEl.current.removeEventListener("wheel", (e) => handleScroll(e));
    };
  }, [useMouseWheel, parentEl]);

  const handleScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.deltaY > 0) {
      sliderRef.current && sliderRef.current.slickNext();
    } else if (e.deltaY < 0) {
      sliderRef.current && sliderRef.current.slickPrev();
    }
  };

  const goToSlide = (index) => {
    sliderRef.current && sliderRef.current.slickGoTo(index);
  };

  return (
    <>
      <div className="relative h-full w-full">
        <Slider
          className={styles["g-slider-vertical"]}
          {...settings}
          ref={sliderRef}
        >
          {children &&
            Children.count(children) > 0 &&
            Children.map(children, (element, idx) => {
              return (
                <>
                  {cloneElement(element, {
                    ref: createRef(idx),
                    className: `mx-auto ${!settings.adaptiveHeight && "h-full"
                      }`,
                  })}
                </>
              );
            })}
        </Slider>
      </div>
    </>
  );
};

Vertical.propTypes = {
  parentEl: PropTypes.any,
  settings: PropTypes.object,
  useMouseWheel: PropTypes.bool,
  children: PropTypes.any,
};

Vertical.defaultProps = {
  parentEl: createRef(null),
  settings: {},
  useMouseWheel: true,
  children: <></>,
};

export default Vertical;
